import theme from "@/styles/theme";
import styled from "styled-components";

export const InputLabelContainer = styled.div`
  display: flex;
  flex: 1;
  margin-bottom: 8px;
  flex-direction: row;
  border-style: solid;
  border-color: ${theme.colors.palete.gold};
  border-width: 1px;
  padding: 10px;
  min-width: 12vw;
  border-radius: 5px;
  align-items: center;
  .column {
    display: flex;
    flex-direction: column;
    margin-left: 0.5vw;
    width: 100%;
  }
`;

export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const LabelText = styled.span`
  font-size: ${theme.fontSize.md};
  font-family: sans-serif;
  font-weight: 800;
  color: white;
  white-space: nowrap;
`;
export const ValueText = styled.span`
  font-size: ${theme.fontSize.md};
  font-family: sans-serif;
  font-weight: 500;
  color: white;
`;
export const DataText = styled.span`
  font-size: ${theme.fontSize.md};
  font-family: sans-serif;
  font-weight: 500;
  margin-left: 5px;
`;
export const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  .couting {
    margin-left: auto;
    margin-right: 1vw;
  }
`;
